import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography, Grid, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '30vh',
        marginTop: theme.spacing(2)
    },
    card: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: '15px',
        margin: theme.spacing(3)
    },
    image: {
        width: 60,
        height: 60,
        margin: theme.spacing(2),
    },
    card1: {
        background: 'linear-gradient(to bottom, #F7A143, #FFFFFF)',
    },
    card2: {
        background: 'linear-gradient(to bottom, #4BAB58, #FFFFFF)',
    },
    card3: {
        background: 'linear-gradient(to bottom, #60329C, #FFFFFF)',
    },
    card4: {
        background: 'linear-gradient(to bottom, #2E91E8, #FFFFFF)',
    },
    content: {
        display: 'flex',
        flexDirection: 'row'
    },
    title: {
        color: 'white',
        marginTop: '3vh',
        textTransform: 'none'
    }

}));

const CardList = () => {
    const classes = useStyles();
    const history = useHistory();
    const paths = ['/digit-ui/citizen/applyOnline', '/digit-ui/employee', '/digit-ui/citizen/feeCalculator', 'digit-ui/citizen/obps/my-applications'];
    const handleCardClick = (path) => {
        history.push(path);
    };

    const cardData = [
        { imageUrl: 'https://i.imgur.com/72lqHju.png', title: 'Online Services', gradientClass: classes.card1 },
        { imageUrl: 'https://i.imgur.com/RLDNCUS.png', title: 'Officer Login', gradientClass: classes.card2 },
        { imageUrl: 'https://i.imgur.com/9piU18h.png', title: 'Fee Calculator', gradientClass: classes.card3 },
        { imageUrl: 'https://i.imgur.com/mfeY0Ib.png', title: 'Check Application Status', gradientClass: classes.card4 },
    ];

    return (
        <Grid container spacing={3} className={classes.root}>
            {cardData.map((data, index) => (
                <Grid item key={index} xs={12} sm={6} md={4} lg={12 / 4}>
                    <Button
                        className={`${classes.card} ${data.gradientClass}`}
                        variant="outlined"
                        onClick={() => handleCardClick(paths[index])}
                    >
                        <CardContent className={classes.content}>
                            <img src={data.imageUrl} alt={data.title} className={classes.image} />
                            <Typography variant="h6" className={classes.title}>{data.title}</Typography>
                        </CardContent>
                    </Button>
                </Grid>
            ))}
        </Grid>
    );
};

export default CardList;
